// extracted by mini-css-extract-plugin
var _1 = "RequestTranslationToolbar-moduleactions__vaT2f";
var _2 = "RequestTranslationToolbar-modulefocused__hi1PF";
var _3 = "RequestTranslationToolbar-modulerequestTranslationToolbar__JtzZZ";
var _4 = "RequestTranslationToolbar-moduleselect__UxH23";
var _5 = "RequestTranslationToolbar-moduleselectButton___vTUa";
var _6 = "RequestTranslationToolbar-moduleselectPlaceholder__KhDRc ButtonSelectControlContentPlaceholder-moduleButtonSelectControlContentPlaceholder__h946D";
var _7 = "RequestTranslationToolbar-moduleselectValueText__o9M4o";
var _8 = "RequestTranslationToolbar-moduleselects__v8Tru";
var _9 = "RequestTranslationToolbar-moduleswitchButton__xT001";
var _a = "RequestTranslationToolbar-moduletranslateButton__kKeva";
var _b = "RequestTranslationToolbar-moduletranslateButtonText__oWsnf";
var _c = "RequestTranslationToolbar-moduletranslateButtonTooltipWrapper__yipyp";
export { _1 as "actions", _2 as "focused", _3 as "requestTranslationToolbar", _4 as "select", _5 as "selectButton", _6 as "selectPlaceholder", _7 as "selectValueText", _8 as "selects", _9 as "switchButton", _a as "translateButton", _b as "translateButtonText", _c as "translateButtonTooltipWrapper" }
